export default __webpack_public_path__ + "static/media/fantom.b36f99ce.png";